export default __webpack_public_path__ + "static/media/3 Pictures.d38fd89d.mp3";